import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { confirmTax } from 'actions';
import { TaxModal } from 'components/SenderInformation/components/TaxModal/TaxModal';
import type { Price } from 'models/price';
import type { RootState } from 'reducers/types';
import {
  amountFrom,
  getSelectedOffer,
  getTaxes,
  hasOnlyGSTTaxes,
  indianPartnerData,
  isOfferDBIN,
} from 'selectors';

const NO_MONEY = {} as Price<string>;

type TaxModalProps = ConnectedProps<typeof connector> & {
  isOpen?: boolean;
  onClose?: () => void;
};

function TaxModalContainerComponent({
  confirmTax,
  hasOnlyGST = false,
  isOfferDBIN = false,
  isOpen = false,
  onClose,
  price = NO_MONEY,
  taxes = [],
  indianPartnerData = {},
}: TaxModalProps) {
  const handleConfirmTax = () => {
    confirmTax();
    onClose?.();
  };

  return (
    <TaxModal
      hasOnlyGST={hasOnlyGST}
      isOfferDBIN={isOfferDBIN}
      isOpen={isOpen}
      onConfirm={handleConfirmTax}
      price={price}
      taxes={taxes}
      indianPartnerData={indianPartnerData}
    />
  );
}

TaxModalContainerComponent.displayName = 'TaxModalContainer';

const mapStateToProps = (state: RootState) => {
  const offer = getSelectedOffer(state);

  return {
    hasOnlyGST: hasOnlyGSTTaxes(state),
    isOfferDBIN: isOfferDBIN(offer),
    price: amountFrom(state),
    taxes: getTaxes(state),
    indianPartnerData: indianPartnerData(state),
  };
};

const mapDispatchToProps = {
  confirmTax,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const TaxModalContainer = connector(TaxModalContainerComponent);

export { TaxModalContainer };
